import React from 'react';

import Announcement, {
	AnnouncementStyle,
} from '~/components/patterns/messages/embedded/Announcement';



type Props = {
	/** Optional Call-to-Action element */
	ctaElement?: React.ReactNode,
	children: React.ReactNode,
	/** Optional title */
	title?: React.ReactNode,
};



const PremiumAnnouncement: React.FC<Props> = (props) => {
	const {
		ctaElement,
		children,
		title,
	} = props;

	return (
		<section className="premium-announcement">
			<Announcement
				compact={true}
				ctaElement={ctaElement}
				style={AnnouncementStyle.Light}
				title={title}
			>
				{children}
			</Announcement>
		</section>
	);
};



export default PremiumAnnouncement;
